var _a;
import { UnitSuffix } from '../../defs';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var viewWidthToPixel = function (value, options) {
    return value * options.viewWidthPixelValue();
};
var viewWidthToCentimeter = function (value, options) {
    return pixel.cm(viewWidthToPixel(value, options));
};
var viewWidthToMillimeter = function (value, options) {
    return pixel.mm(viewWidthToPixel(value, options));
};
var viewWidthToQuarter = function (value, options) {
    return pixel.Q(viewWidthToPixel(value, options));
};
var viewWidthToInch = function (value, options) {
    return pixel.in(viewWidthToPixel(value, options));
};
var viewWidthToPica = function (value, options) {
    return pixel.pc(viewWidthToPixel(value, options));
};
var viewWidthToPoint = function (value, options) {
    return pixel.pt(viewWidthToPixel(value, options));
};
var viewWidthToREM = function (value, options) {
    return pixel.rem(viewWidthToPixel(value, options), options);
};
var viewWidthToEM = function (value, options) {
    return pixel.em(viewWidthToPixel(value, options), options);
};
var viewWidthToViewHeight = function (value, options) {
    return pixel.vh(viewWidthToPixel(value, options), options);
};
var viewWidthToViewMin = function (value, options) {
    return pixel.vmin(viewWidthToPixel(value, options), options);
};
var viewWidthToViewMax = function (value, options) {
    return pixel.vmax(viewWidthToPixel(value, options), options);
};
export var viewWidth = (_a = {},
    _a[UnitSuffix.Pixel] = viewWidthToPixel,
    _a[UnitSuffix.Centimeter] = viewWidthToCentimeter,
    _a[UnitSuffix.Millimeter] = viewWidthToMillimeter,
    _a[UnitSuffix.Quarter] = viewWidthToQuarter,
    _a[UnitSuffix.Inch] = viewWidthToInch,
    _a[UnitSuffix.Pica] = viewWidthToPica,
    _a[UnitSuffix.Point] = viewWidthToPoint,
    _a[UnitSuffix.REM] = viewWidthToREM,
    _a[UnitSuffix.EM] = viewWidthToEM,
    _a[UnitSuffix.ViewWidth] = noConvert,
    _a[UnitSuffix.ViewHeight] = viewWidthToViewHeight,
    _a[UnitSuffix.ViewMin] = viewWidthToViewMin,
    _a[UnitSuffix.ViewMax] = viewWidthToViewMax,
    _a);
//# sourceMappingURL=view-width.js.map